module.exports = __webpack_public_path__ + "img/physics6.43ab74d6.png";